<template>
    <ValidationObserver ref="validationObserver" slim>
        <div>
            <ErrorLogShower />
            <Progressbar processType="SnA" :currentStepIndex="0" />

            <div class="contentblock">
                <section class="contentblock__content">

                    <MigrosLoginInfo containerClass="shop__fieldgroup shop__fieldgroup--no-separator shop__fieldgroup--no-padding-bottom shop__fieldgroup--no-padding-top" />

                    <div class="shop__fieldgroup" v-if="IsPartnerLink">
                        <div class="shop__fieldgroup-title">{{Strings['Shop.Partner.Subtitle']}}</div>
                        <p class="shop__partner-text">{{Strings['Shop.Partner.Intro']}}</p>
                        <p class="shop__partner-text">{{Strings['Shop.Partner.TextTankrevision']}}</p>
                        <p class="shop__partner-text">
                            <strong>{{Strings['Shop.Partner.TelOrderTitle']}}</strong>
                            <br />
                            {{Strings['Shop.Partner.TelOrderText']}}
                        </p>
                    </div>

                    <div class="shop__fieldgroup shop__fieldgroup--no-separator shop__fieldgroup--no-padding-bottom" v-if="CouponPromo">
                        <div class="shop__options-block">
                            <div class="buy-energy-header__product-details__teaser">
                                <div class="buy-energy-header__product-details__title">
                                    {{CouponPromo.Title}}
                                    <svg viewBox="0 0 56 56"
                                         xmlns="http://www.w3.org/2000/svg" class="buy-energy-header__product-details__title__promo-icon">
                                        <g fill="none" fill-rule="evenodd">
                                            <path fill="currentColor" d="m28 52.7-5.5 2.8-3.9-4.7-6.2.5-1.8-5.9-5.9-1.8.5-6.2-4.7-3.9L3.3 28 .5 22.5l4.7-3.9-.5-6.2 5.9-1.8 1.8-5.9 6.2.5L22.5.5 28 3.3 33.5.5l3.9 4.7 6.2-.5 1.8 5.9 5.9 1.8-.5 6.2 4.7 3.9-2.8 5.5 2.8 5.5-4.7 3.9.5 6.2-5.9 1.8-1.8 5.9-6.2-.5-3.9 4.7z"></path>
                                            <path d="M37 41.4c-1.5 0-2.8-.5-3.9-1.4-1-.9-1.5-2.1-1.5-3.8v-3.7c0-1.7.5-3 1.5-3.8 1-1 2.4-1.4 4-1.4 1.5 0 2.9.4 3.9 1.3 1 1 1.5 2.2 1.5 3.9v3.7c0 1.6-.5 3-1.5 3.8-1 1-2.4 1.4-4 1.4ZM24 41h-3.8l12.7-26.9h3.9L24 41.2Zm-4.1-13c-1.6 0-3-.4-4-1.3-1-1-1.5-2.2-1.5-3.9v-3.7c0-1.6.5-2.9 1.6-3.8 1-1 2.3-1.4 3.9-1.4s2.9.5 4 1.4c1 .8 1.5 2.1 1.5 3.8v3.7c0 1.7-.6 3-1.6 3.8-1 1-2.3 1.4-4 1.4Zm19 4.5c0-1.4-.6-2.1-1.8-2.1-1.3 0-2 .7-2 2.1V36c0 1.5.7 2.2 2 2.2 1.2 0 1.9-.7 1.9-2.2v-3.4ZM22 19.3c0-1.4-.7-2.1-2-2.1s-2 .7-2 2.1v3.5c0 1.4.7 2.1 2 2.1s2-.7 2-2.1v-3.5Z" fill="#A4091E" fill-rule="nonzero"></path>
                                        </g>
                                    </svg>
                                </div>
                                <div class="buy-energy-header__product-details__teaser__content migrol-rt-content" v-html="CouponPromo.Content"></div>
                            </div>
                        </div>
                    </div>

                    <div class="shop__fieldgroup shop__fieldgroup--no-separator shop__fieldgroup--no-padding-bottom">
                        <div class="shop__materials">
                            <div class="shop__material shop__material--selected shop__material--single">
                                <div class="shop__material-block-desc shop__material-block-desc--grid">
                                    <div class="shop__material-icon"><img :src="Material.iconUrl" width="100" /></div>
                                    <div class="shop__material-name" v-html="migrolFormatText(Material.name)"></div>
                                    <div class="shop__material-description" v-html="Material.description"></div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="shop__fieldgroup shop__fieldgroup--no-separator shop__fieldgroup--no-padding-bottom">
                        <SnaAddresses />
                    </div>

                    <div class="shop__fieldgroup shop__fieldgroup--no-separator shop__fieldgroup--no-padding-bottom shop__fieldgroup--no-padding-top" v-if="isZipCodeBlocked">
                        <div class="shop__error-message-block">{{Strings['Shop.ZipCodeUnavailable']}}</div>
                    </div>

                    <div class="migrol-form__buttons" v-if="!isZipCodeBlocked">
                        <AjaxButton :isWaitingForAjax="isWaitingForAjax" :label="Strings['Shop.ButtonContinueToEquipment']" @buttonClick="nextClick" />
                    </div>

                </section>
            </div>

        </div>
    </ValidationObserver>
</template>

<script>
    import { mapState, mapActions, mapGetters } from 'vuex'
    import { mapFilters } from '@/utils/vueFilters';
    import SnaAddresses from '@/components/_common/SnaAddresses'
    import { ValidationObserver } from 'VeeValidate'
    import ErrorLogShower from '../_common/ErrorLogShower'
    import Transaction from '@/models/Transaction'
    import Progressbar from '../_common/Progressbar'
    import { doValidation, stepBeforeRouteLeave } from '@/utils/utils'

    export default {
        computed: {
            ...mapState([
                'Strings',
                'IsPartnerLink',
                'CouponPromo'
            ]),
            ...mapGetters([
                'isWaitingForAjax',
                'isZipCodeBlocked'
            ]),
            CurrentTransaction() {
                return Transaction.query().with(['material']).first();
            },
            Material() {
                return this.CurrentTransaction.material;
            },
            AllowedNavigationPaths() {
                let paths = [];
                //allow back to step 1
                paths.push({ path: '/', requiresValidation: false });
                //forward to review step
                paths.push({ path: '/equipment', requiresValidation: true });

                return paths;
            }
        },
        methods: {
            ...mapActions([
                'FindEquipments'
            ]),
            ...mapFilters([
                'migrolFormatText'
            ]),
            nextClick() {
                var vm = this;
                doValidation(vm.$refs.validationObserver, () => {
                    vm.FindEquipments().then((success) => {
                        if (success) {
                            vm.$router.push('/equipment').catch(() => { });
                        }
                    });
                });
            }
        },
        mounted() {
        },
        beforeRouteLeave(to, from, next) {
            stepBeforeRouteLeave(this.AllowedNavigationPaths, this.$refs.validationObserver, to, next);
        },
        components: {
            ValidationObserver,
            SnaAddresses,
            ErrorLogShower,
            Progressbar
        }
    };
</script>